import { getCell, getSheet, getSheetIndex, getColumn, setCell } from '../base/index';
import { setLinkModel, getRangeIndexes, updateCell, getSwapRange, isLocked, importModelUpdate } from '../common/index';
import { isNullOrUndefined } from '@syncfusion/ej2-base';
/**
 * The `WorkbookHyperlink` module is used to handle Hyperlink action in Spreadsheet.
 */
export class WorkbookHyperlink {
    /**
     * Constructor for WorkbookSort module.
     *
     * @param {Workbook} parent - Specifies the workbook.
     */
    constructor(parent) {
        this.parent = parent;
        this.addEventListener();
    }
    /**
     * To destroy the sort module.
     *
     * @returns {void} - To destroy the sort module.
     */
    destroy() {
        this.removeEventListener();
        this.parent = null;
    }
    addEventListener() {
        this.parent.on(setLinkModel, this.setLinkHandler, this);
        this.parent.on(importModelUpdate, this.updateHyperLinksFromSheet, this);
    }
    removeEventListener() {
        if (!this.parent.isDestroyed) {
            this.parent.off(setLinkModel, this.setLinkHandler);
            this.parent.off(importModelUpdate, this.updateHyperLinksFromSheet);
        }
    }
    setLinkHandler(args) {
        let hyperlink = args.hyperlink;
        let cellAddr = args.cell;
        let sheet;
        if (cellAddr && cellAddr.indexOf('!') !== -1) {
            const lastIndex = cellAddr.lastIndexOf('!');
            sheet = getSheet(this.parent, getSheetIndex(this.parent, cellAddr.substring(0, lastIndex)));
            cellAddr = cellAddr.substring(lastIndex + 1);
            if (!sheet) {
                return;
            }
        }
        else {
            sheet = this.parent.getActiveSheet();
            cellAddr = cellAddr || sheet.selectedRange;
        }
        const isProtected = !args.triggerEvt && sheet.isProtected;
        if (isProtected && !sheet.protectSettings.insertLink) {
            return;
        }
        const cellIdx = getSwapRange(getRangeIndexes(cellAddr));
        if (typeof (hyperlink) === 'string') {
            if (hyperlink.toLowerCase().indexOf('www.') === 0) {
                hyperlink = 'http://' + hyperlink;
            }
        }
        else {
            if (hyperlink.address.toLowerCase().indexOf('www.') === 0) {
                hyperlink.address = 'http://' + hyperlink.address;
            }
        }
        let cellModel;
        const activeCell = getRangeIndexes(sheet.activeCell);
        for (let rIdx = cellIdx[0]; rIdx <= cellIdx[2]; rIdx++) {
            for (let cIdx = cellIdx[1]; cIdx <= cellIdx[3]; cIdx++) {
                if (isProtected && isLocked(getCell(rIdx, cIdx, sheet), getColumn(sheet, cIdx))) {
                    continue;
                }
                const cell = getCell(rIdx, cIdx, sheet, null, true);
                if (cell.rowSpan < 1 || cell.colSpan < 1) {
                    continue;
                }
                cellModel = { hyperlink: typeof hyperlink === 'object' ? Object.assign({}, hyperlink) : hyperlink };
                if (!isNullOrUndefined(args.displayText)) {
                    if (args.triggerEvt || args.isUndoRedo) {
                        if (rIdx === activeCell[0] && cIdx === activeCell[1]) {
                            cellModel.value = args.displayText;
                            delete cellModel.formattedText;
                        }
                    }
                    else {
                        cellModel.value = args.displayText;
                        delete cellModel.formattedText;
                    }
                }
                cellModel.style = { textDecoration: 'underline', color: '#00e' };
                updateCell(this.parent, sheet, { cell: cellModel, rowIdx: rIdx, colIdx: cIdx, preventEvt: !args.triggerEvt });
                if (!isNullOrUndefined(args.triggerEvt)) {
                    this.parent.setUsedRange(rIdx, cIdx, sheet);
                }
            }
        }
        this.parent.setUsedRange(cellIdx[2], cellIdx[3]);
    }
    updateHyperLinksFromSheet() {
        this.parent.sheets.forEach((sheet) => {
            if (sheet.hyperLinks && sheet.hyperLinks.length > 0) {
                sheet.hyperLinks.forEach((model) => {
                    const indexes = model.range;
                    setCell(indexes[0], indexes[1], sheet, { hyperlink: model.address }, true);
                });
                delete sheet.hyperLinks;
            }
        });
    }
    /**
     * Gets the module name.
     *
     *@returns {string} - returns the module name.
     */
    getModuleName() {
        return 'workbookHyperlink';
    }
}
